import { storage, cloudFunction } from '../../config/firebaseConfig';
import firebase from "firebase/app";
import functions from "firebase/functions";

export const readThisNotification = (userData) => {
    return async (dispatch, getState, { getFirestore }) => {
        // async call
        const firestore = getFirestore();

        const { totalNotifications, totalNotificationsRead } = userData;
        if ((totalNotificationsRead ?? 0) < (totalNotifications)) {
            await firestore.collection('Users').doc(userData.uid).update({
                totalNotificationsRead: totalNotifications
            });
        }

        return dispatch({
            type: "READ_THIS_NOTIFICATION",
        });
    }
}

export const readThisProjectNotification = (proid, meta) => {
    return async (dispatch, getState, { getFirebase }) => {
        // async call
        const firebase = getFirebase();
        if (meta) {
            const { totalNotifications, totalNotificationsRead } = meta;
            if (totalNotificationsRead < totalNotifications) {
                await firebase.database().ref().child(`ProjectsMeta/${proid}/Notifications`).set({
                    totalNotificationsRead: totalNotifications
                });
            }

            return dispatch({
                type: "READ_THIS_NOTIFICATION",
            });
        }

    }
}

export const readThisCompanyNotification = (coid, meta) => {
    return async (dispatch, getState, { getFirebase }) => {
        // async call
        const firebase = getFirebase();
        if (meta) {
            const { totalNotifications, totalNotificationsRead } = meta;
            if ((totalNotificationsRead ?? 0) < (totalNotifications)) {
                await firebase.database().ref().child(`CompaniesMeta/${coid}/Notifications`).update({
                    totalNotificationsRead: totalNotifications
                });
            }

            return dispatch({
                type: "READ_THIS_NOTIFICATION",
            });
        }

    }
}

